<aside
  [ngClass]="{ 'w-16': isCollapsed, 'w-64': !isCollapsed }"
  class="flex h-screen flex-col border-r border-neutral-gray30 bg-neutral-white shadow-sm transition-all duration-300">
  <div class="flex items-center justify-center px-4 py-6">
    <img
      class="mb-10"
      src="assets/images/logo.svg"
      alt="Cardio Explorer"
      width="175"
      height="40"
      *ngIf="!isCollapsed" />
    <!-- <button (click)="toggleSidebar()" class="rounded p-2 hover:bg-neutral-gray20">
      <img src="assets/icons/menu.svg" alt="Toggle Sidebar" class="h-5 w-5" />
    </button> -->
  </div>

  <nav class="flex h-full flex-col">
    <ul class="space-y-1">
      <li *ngFor="let item of navItems">
        <a
          [routerLink]="item.route"
          routerLinkActive="bg-neutral-gray20 text-neutral-gray70"
          class="mx-auto flex w-[90%] items-center gap-3 rounded-lg px-4 py-3 text-neutral-gray70 transition hover:bg-neutral-gray20">
          <img [src]="item.icon" alt="{{ item.label }}" class="h-5 w-5" />
          <span *ngIf="!isCollapsed" class="text-sm font-medium leading-none">{{ item.label | translate }}</span>
        </a>
      </li>
      <!-- MVP-15: Super User nav entry — only visible when the DB flag is set. -->
      <ng-container *ngIf="isSuperUser$ | async">
        <li *ngFor="let item of superUserNavItems">
          <a
            [routerLink]="item.route"
            routerLinkActive="bg-neutral-gray20 text-neutral-gray70"
            class="mx-auto flex w-[90%] items-center gap-3 rounded-lg px-4 py-3 text-neutral-gray70 transition hover:bg-neutral-gray20">
            <img [src]="item.icon" alt="{{ item.label }}" class="h-5 w-5" />
            <span *ngIf="!isCollapsed" class="text-sm font-medium leading-none">{{ item.label | translate }}</span>
          </a>
        </li>
      </ng-container>
    </ul>

    <div class="flex-grow"></div>
    <hr class="mx-auto my-4 w-[85%] rounded-lg border-[1px] border-neutral-gray30" />
    <ul class="mb-6 space-y-1">
      <li *ngFor="let item of secondaryNavItems">
        <a
          *ngIf="!item.isExternal"
          [routerLink]="item.label === 'shared.components.sidebar.nav.settings' ? item.route : null"
          routerLinkActive="bg-neutral-gray20 text-neutral-gray70"
          class="mx-auto flex w-[90%] items-center gap-3 rounded-lg px-4 py-3 text-neutral-gray70 transition hover:bg-neutral-gray20">
          <img [src]="item.icon" alt="{{ item.label }}" class="h-5 w-5" />
          <span *ngIf="!isCollapsed" class="text-sm font-medium leading-none">{{ item.label | translate }}</span>
        </a>
        <a
          *ngIf="item.isExternal"
          [href]="getExplorisHealthUrl(currentLang, item.route)"
          target="_blank"
          rel="noopener noreferrer"
          class="mx-auto flex w-[90%] items-center gap-3 rounded-lg px-4 py-3 text-neutral-gray70 transition hover:bg-neutral-gray20">
          <img [src]="item.icon" alt="{{ item.label }}" class="h-5 w-5" />
          <span *ngIf="!isCollapsed" class="text-sm font-medium leading-none">{{ item.label | translate }}</span>
        </a>
      </li>
    </ul>
  </nav>
</aside>
